import { Typography } from "@kirvanobr/typography";

import { HeaderPageProps } from "./HeaderPage.types";

export const HeaderPage = ({ children, title }: HeaderPageProps) => {
  return (
    <div className="flex flex-col lg:flex-row justify-between lg:items-center mb-8 px-1">
      <Typography variant="title" size="t4" weight="bold" className="text-foreground-800">
        {title}
      </Typography>
      {children}
    </div>
  );
};
